<template>
  <div>
    <v-container v-if='budget.archived'>
      <v-alert type='error'>Budget is Archived</v-alert>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics
            v-if='budget'
            :budget='budget'
            @update='update'
          ></basics>
        </v-col>
        <v-col cols='12' md='5'>
          <categories
            :categories='categories'
            :loading='isLoadingCategories'
            @saveCategory='saveCategory'
          ></categories>
        </v-col>
        <v-col cols='12' md='3'>
          <totals
            v-if='budget'
            :budget='budget'
            :lines='lines'
            :loading='isLoadingLines'
          ></totals>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12'>
          <lines
            v-if='budget'
            :budget='budget'
            :lines='lines'
            :categories='categories'
            :loading='isLoadingLines || isLoadingCategories'
            @saveLine='saveLine'
          ></lines>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from '@/modules/management/components/budgets/Basics'
import Lines from '@/modules/management/components/budgets/Lines'
import Totals from '@/modules/management/components/budgets/Totals'
import Categories from '@/modules/management/components/budgets/Categories'
import budgetsAPI from '@/modules/management/api/budgets'
import miscServices from '@/services/misc'
import _ from 'lodash'

export default {
  name: 'budget-overview',
  data: () => ({
    isLoadingLines: false,
    isLoadingCategories: false,
    lines: [],
    categories: [],
  }),
  props: {
    budget: {
      required: true
    }
  },
  mounted () {
    this.getData()
  },
  computed: {
    subtitle () {
      if (this.budget) {
        return this.budget.description
      }
      return ''
    }
  },
  methods: {
    async getData () {
      this.isLoadingCategories = true
      this.isLoadingLines = true
      this.categories = await budgetsAPI.getCategories()
      this.isLoadingCategories = false
      this.lines = await budgetsAPI.getBudgetLineItems(this.$route.params.id)
      this.lines = _.orderBy(this.lines, ['division_obj.division', 'main_category_obj.description', 'sub_category_obj.description', 'sub_sub_category_obj.description'])
      this.isLoadingLines = false
    },
    update (obj) {
      this.$emit('update', obj)
    },
    async saveCategory (cat) {
      this.isLoadingCategories = true
      if (cat.id) {
        let tmp = await budgetsAPI.updateCategory(cat)
        this.categories = miscServices.replaceObject(this.categories, tmp)

      } else {
        this.categories.push(await budgetsAPI.createCategory(cat))
      }
      this.isLoadingCategories = false
    },
    async saveLine (line) {
      this.isLoadingLines = true
      if (line.division === undefined) {
        line.division = null
      }
      if (line.id) {
        let tmp = await budgetsAPI.updateBudgetLineItem(line)
        this.lines = miscServices.replaceObject(this.lines, tmp)
      } else {
        this.lines.push(await budgetsAPI.createBudgetLineItem(line))
      }
      this.lines = _.orderBy(this.lines, ['division_obj.division', 'main_category_obj.description', 'sub_category_obj.description', 'sub_sub_category_obj.description'])
      this.isLoadingLines = false
    },
  },
  components: {
    'basics': Basics,
    'lines': Lines,
    'totals': Totals,
    'categories': Categories
  }
}
</script>
